<template>
  <div>
   <div>
      <div class="VueCarousel-slide active" ref="story1">
        <div class="padding">
          <div>
            <p> &nbsp;</p>
            <p> I've written so much of this city, tried to fix it in place in a book for Oska.</p><br>
            <p>but somehow I haven't found a way to put you in it</p><br>
            <p>maybe I don't want to get it wrong</p><br>
            <p> &nbsp;</p>
            <p>I wanted to say something to you</p><br>
            <p>but just to you</p><br>
            <p>not something to be fixed, </p><br>
            <p>not a memory</p><br>
            <p>a hope</p><br>
            <p> &nbsp;</p>
            <p>I wrote it down, </p><br>
            <p> &nbsp;</p>
            <p>I tore out the page and I put it in Oska's bag</p><br>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </div>
        </div>
      </div>
      <div class="VueCarousel-slide hidden" ref="story2">
        <div class="padding">
          <div>
            <span class="arch">
              <p>This city is no longer the place it was when I arrived here.</p>
              <br>
              <p>This city is more complex, is an amalgam of when and where and how.</p>
              <p></p><br>
              <p>There is a statue of a veiled woman in a backstreet behind a market and when I first stood before it I could see its face, but no more.</p><br>
              <p>There are gryphons on the bridge over the river and I swear those pedestals were empty. </p><br>
              <p>The streets are crashing together and the river is rising. </p><br>
              <p> &nbsp;</p>
              <p>I turned down a street, and descended a steep hill before the roadway opened out onto this vista. </p><br>
              <p>A burned out gaming hall. Covered in wood and daubed with paint.</p><br>
              <p>There are lines on the building, and I saw something in their form. I can see wreaths of sunlight there, and smell fresh roses. I do not know whether these sensations have their root here, or in Portus.</p><br>
              <p>I recalled the inanities offered by the closter devoted to the word and the form of the city. I always disregarded their laments, crying in the street that the architecture and lines of the city describe some monstrous design, but here, stood in this street and lost in another place, their delusions seem less remote, more tangible. </p><br>
              <p>I drew the building, and found myself marking the drawing, and suddenly it all became so clear.</p><br>
              <p> &nbsp;</p>
              <p> &nbsp;
              This place is only an echo</p><br>
              <p>the image that keeps returning to me, of dust and the silence and a city falling, it is a vision of this echo fading,
              of this city falling.</p><br>
              <p> &nbsp;</p>
              <p>And I realise that I'm living in this echo</p><br>
              <p>and once it is gone there will only be Portus. Portus will remain, in all it's imperfection, it's inequality. It will stand, and this place will be no more.</p><br>
              <p>I have to find a way back before the silence</p><br>
              <p>And what if I cannot make it? What if I cannot return?</p><br>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
              <p>I search, my heart under pressure, urgency burns through me</p><br>
              <p>yet I can't grasp what it is I'm looking for</p><br>
              <p>each street and corner and building becomes blurred</p><br>
              <p>as I pass them with ever increasing speed</p><br>
              <p>am I running? i slow down, and try to pay attention . . </p><br>
              <p> &nbsp;</p>
              <p>to notice, what? </p><br>
              <p> &nbsp;</p>
              <p>Portus? </p><br>
              <p> &nbsp;</p>
              <p>maybe just a trace, a source, </p><br>
              <p>something as fluid as me, out of place</p><br>
              <p>something that has shifted</p><br>
              <p> &nbsp;</p>
              <p>a soft boundary</p><br>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'Search'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
